import { View } from "react-native";
import { Text } from "react-native-paper";

import { LineItemPreview, OrderPreview } from "./types";
import { formatCurrency } from "../utils";

const formatAmount = (cents: number) => formatCurrency({ value: cents / 100, unit: "usd" });

export default function PaymentSection({
  offlineFee,
  orderPreview,
}: {
  offlineFee: LineItemPreview | null;
  orderPreview: OrderPreview | null;
}) {
  const offlinePrice = Number(offlineFee?.priceCents) || 0;
  const orderPrice = Number(orderPreview?.lineItemsTotal) || 0;
  return (
    <View testID="payment-section">
      <View className="bg-sky-light h-[1px]" />
      <View className="my-8">
        <Text className="text-large-normal font-700 pb-2 mb-4">Payment Summary</Text>
        {orderPreview?.lineItems.map((lineItem, idx) => (
          <View key={idx}>
            <View className="flex flex-row justify-between items-center w-full pt-1" testID="order-lineitem">
              <Text className="text-regular-normal">{lineItem.name}</Text>
              <Text className="text-regular-normal">{formatAmount(lineItem.priceCents)}</Text>
            </View>
            {lineItem.notes && <Text className="text-sm text-ink-lighter text-wrap w-full pr-4">{lineItem.notes}</Text>}
          </View>
        ))}
        {offlineFee && (
          <View className="flex flex-row justify-between items-center w-full py-3" testID="offline-fee">
            <View className="flex-1">
              <Text data-testid="what" className="text-regular-normal">
                *Course Fees (Pay On-site)
              </Text>
              <Text className="text-sm text-ink-lighter text-wrap w-full pr-4">
                Not included in your online payment, {formatAmount(offlinePrice)} will be collected on-site.
              </Text>
            </View>
            <View>
              <Text className="text-regular-normal" testID="que">
                {formatAmount(offlinePrice)}
              </Text>
            </View>
          </View>
        )}
        <View className="bg-sky-light h-[1px] my-3" />
        <View className="flex flex-row justify-between items-center w-full py-2.5" testID="total-due">
          <Text className="text-large-normal font-700">Total Due</Text>
          <Text className="text-regular-normal">{formatAmount(orderPrice + offlinePrice)}</Text>
        </View>
        {offlineFee && (
          <View className="flex flex-row justify-between items-center w-full py-2.5" testID="offline-due">
            <Text className="text-regular-normal">Due On-Site</Text>
            <Text className="text-regular-normal">{formatAmount(offlinePrice)}</Text>
          </View>
        )}
        {orderPreview && (
          <View className="flex flex-row justify-between items-center w-full py-2.5" testID="order-due">
            <Text className="text-regular-normal">Due Now</Text>
            <Text className="text-regular-normal" data-testid="payment">
              {formatAmount(orderPrice)}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
}
